export default state => ({
  ...state,
  loadingDataOnPageLoad: null,
  sdkFailure: false
});
